import { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import { GroupingPanel } from '@devexpress/dx-react-scheduler-material-ui';
import { SchedulerContext } from '../../SchedulerContext';

const useStyles = makeStyles()(theme => ({
  groupingPanelCellComponentDayView: {
    '& > :first-of-type': {
      '& > :first-of-type': {
        textAlign: 'left',
        paddingRight: 15,
        [theme.breakpoints.down('md')]: {
          fontSize: theme.typography.pxToRem(10),
        },
      },
    },
  },
  resourceTitleWidthMonthView: {
    '& > :first-of-type': {
      '& > :first-of-type': {
        maxWidth: 'unset',
      },
    },
  },
  resourceTitleWidthDayView: {
    '& > :first-of-type': {
      '& > :first-of-type': {
        maxWidth: '100%',
      },
    },
  },
}));

export const GroupingPanelCellComponent = (props: GroupingPanel.CellProps) => {
  const schedulerContext = useContext(SchedulerContext);
  const overView = schedulerContext.overView;
  const { classes, cx } = useStyles();
  return (
    <GroupingPanel.Cell
      {...props}
      className={cx({
        [classes.groupingPanelCellComponentDayView]: overView,
        [classes.resourceTitleWidthMonthView]:
          overView && schedulerContext.currentViewName === 'Month',
        [classes.resourceTitleWidthDayView]:
          overView && schedulerContext.currentViewName === 'Day',
      })}
    ></GroupingPanel.Cell>
  );
};
